import {
  DEFAULT_API_PATHS,
  SERVICE_DEFAULT,
  SERVICE_JOBPOSTING
} from '@shared/config';
import isObject from '@shared/helpers/isObject';

/**
 * For ATMT widgets, jobposting api path needs to be suffixed with organization id
 */
const maybeInjectOrganizationId = (apiPaths, organizationId) => {
  if (organizationId) {
    return {
      ...apiPaths,
      [SERVICE_JOBPOSTING]: `${apiPaths[SERVICE_JOBPOSTING]}/${organizationId}`
    };
  }
  return apiPaths;
};

/**
 * overide default api paths coming from external
 * configuration like widget configuration from magnolia
 *
 * @param {object | string} apiPath
 * @param {string} defaultApiPath
 * @param {string} organizationId (optional, will be appended into jobposting endpoints if provided)
 * @returns api path object
 */
const createApiPath = (apiPath, defaultApiPath, organizationId) => {
  const defaultPaths = maybeInjectOrganizationId(
    DEFAULT_API_PATHS,
    organizationId
  );
  const apiObj = isObject(apiPath)
    ? {
        ...defaultPaths,
        ...{[SERVICE_DEFAULT]: defaultPaths[defaultApiPath]},
        ...apiPath
      }
    : {
        ...defaultPaths,
        ...(typeof apiPath === 'string' && apiPath.length > 0
          ? {[SERVICE_DEFAULT]: apiPath}
          : {
              [SERVICE_DEFAULT]: defaultPaths[defaultApiPath ?? SERVICE_DEFAULT]
            })
      };
  return apiObj;
};

export default createApiPath;
